<template>
  <el-dialog
    id="myOrderDetails"
    v-draggable
    :visible.sync="dialogVisible"
    :modal-append-to-body="true"
    :close-on-click-modal="false"
    :modal="false"
    @close="htmlDataDialogClose"
    width="100%"
  >
    <!-- 采购订单 详情 -->
    <purchaseOrderDetails
      v-if="dialogVisible && homeIndex == 15"
      :routeType="routeType"
      :routeQuery="routeQuery"
      @backHome="htmlDataDialogClose"
    ></purchaseOrderDetails>
    <!-- 采购收货 详情 -->
    <purchaseStorageDetails
      v-if="dialogVisible && homeIndex == 16"
      :routeType="routeType"
      :routeQuery="routeQuery"
      @backHome="htmlDataDialogClose"
    ></purchaseStorageDetails>
    <!-- 采购对账 详情 -->
    <purchaseBillDetails
      v-if="dialogVisible && homeIndex == 18"
      :routeType="routeType"
      :routeQuery="routeQuery"
      @backHome="htmlDataDialogClose"
    ></purchaseBillDetails>
    <!-- 产品委外详情 -->
    <outsourcingProductOrderDetails
      v-if="dialogVisible && homeIndex == 47"
      :routeType="routeType"
      :routeQuery="routeQuery"
      @backHome="htmlDataDialogClose"
    >
    </outsourcingProductOrderDetails>
    <outsourcingProductMaterialsDetails
      v-if="dialogVisible && homeIndex == 48"
      :routeType="routeType"
      :routeQuery="routeQuery"
      @backHome="htmlDataDialogClose"
    ></outsourcingProductMaterialsDetails>
    <!-- 产品委外退料 -->
    <outsourcingProductReturnDetails
      v-if="dialogVisible && homeIndex == 49"
      :routeType="routeType"
      :routeQuery="routeQuery"
      @backHome="htmlDataDialogClose"
    ></outsourcingProductReturnDetails>
    <!-- 产品委外发货 -->
    <outsourcingProductFinishDetails
      v-if="dialogVisible && homeIndex == 50"
      :routeType="routeType"
      :routeQuery="routeQuery"
      @backHome="htmlDataDialogClose"
    ></outsourcingProductFinishDetails>
    <!-- 工序订单详情 -->
    <outsourcingProcessesOrderDetails
      v-if="dialogVisible && homeIndex == 127"
      :routeType="routeType"
      :routeQuery="routeQuery"
      @backHome="htmlDataDialogClose"
    ></outsourcingProcessesOrderDetails>
    <!-- 工序收料详情 -->
    <outsourcingProcessesMaterialsDetails
      v-if="dialogVisible && homeIndex == 170"
      :routeType="routeType"
      :routeQuery="routeQuery"
      @backHome="htmlDataDialogClose"
    ></outsourcingProcessesMaterialsDetails>
    <!-- 工序退料详情 -->
    <outsourcingProcessesReturnDetails
      v-if="dialogVisible && homeIndex == 171"
      :routeType="routeType"
      :routeQuery="routeQuery"
      @backHome="htmlDataDialogClose"
    ></outsourcingProcessesReturnDetails>
    <!-- 工序委外发货详情 -->
    <outsourcingProcessesFinishDetails
      v-if="dialogVisible && homeIndex == 172"
      :routeType="routeType"
      :routeQuery="routeQuery"
      @backHome="htmlDataDialogClose"
    ></outsourcingProcessesFinishDetails>
  </el-dialog>
</template>
<script>
import purchaseOrderDetails from "@/views/purchase/components/order_details.vue";
import purchaseStorageDetails from "@/views/purchase/components/storage_details.vue";
import purchaseBillDetails from "@/views/purchase/components/bill_details.vue";
import outsourcingProductReturnDetails from "@/views/outsourcingProduct/components/return_details.vue";
import outsourcingProductFinishDetails from "@/views/outsourcingProduct/components/finish_details.vue";
import outsourcingProductOrderDetails from "@/views/outsourcingProduct/components/order_details.vue";
import outsourcingProductMaterialsDetails from "@/views/outsourcingProduct/components/materials_details.vue";

import outsourcingProcessesOrderDetails from "@/views/outsourcingProcesses/components/order_details.vue";
import outsourcingProcessesMaterialsDetails from "@/views/outsourcingProcesses/components/materials_details.vue";
import outsourcingProcessesReturnDetails from "@/views/outsourcingProcesses/components/return_details.vue";
import outsourcingProcessesFinishDetails from "@/views/outsourcingProcesses/components/finish_details.vue";
export default {
  components: {
    purchaseOrderDetails,
    purchaseStorageDetails,
    purchaseBillDetails,
    outsourcingProductReturnDetails,
    outsourcingProductFinishDetails,
    outsourcingProductOrderDetails,
    outsourcingProductMaterialsDetails,
    outsourcingProcessesOrderDetails,
    outsourcingProcessesMaterialsDetails,
    outsourcingProcessesReturnDetails,
    outsourcingProcessesFinishDetails,
  },
  props: {
    // 页面传进来判断入库的值
    routeType: {
      type: Array,
      default: undefined,
    },
    // 页面传进来的值
    routeQuery: {
      default: () => ({}),
    },
    modelType: {
      type: Number,
      default: undefined,
    },
    // 页面值
    homeIndex: {
      type: Number,
      default: false,
    },
    // 是否弹出
    visible: {
      type: Boolean,
      default: false,
    },
    // 采购所需的参数
    isBack: {
      type: Boolean,
      default: null,
    },
  },
  created() {},
  watch: {
    visible(val) {
      this.dialogVisible = val;
    },
    dialogVisible(val) {
      this.$emit("dialogVisible", val);
    },
  },
  data() {
    return {
      dialogVisible: this.visible,
    };
  },
  methods: {
    htmlDataDialogClose() {
      try {
        this.dialogVisible = false;
        this.$emit("htmlDataDialogClose");
      } catch (error) {
        console.log("-*---", error);
      }
    },
  },
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
::v-deep .el-dialog__header {
  padding: 8px !important;
  padding-top: 0px !important;
}
::v-deep .el-upload--picture-card {
  background-color: #fbfdff;
  border: 1px dashed #c0ccda;
  border-radius: 6px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 148px;
  height: 148px;
  cursor: pointer;
  line-height: 146px;
  vertical-align: top;
}
::v-deep .el-upload-list--picture-card .el-upload-list__item {
  background-color: #fbfdff;
  border: 1px dashed #c0ccda;
  border-radius: 6px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 148px;
  height: 148px;
  cursor: pointer;
  line-height: 146px;
  vertical-align: top;
}
::v-deep .el-dialog > .el-dialog__header > .el-dialog__headerbtn {
  display: none;
}
</style>
